<div class="row">
  <div class="col-12">
    <app-label label="Nazwa cmentarza:">
      {{ application?.cemeteryName || '-' }}
    </app-label>
  </div>
  <div class="col-12">
    <app-label label="Typ grobu:">
      {{ application?.graveType || '-' }}
    </app-label>
  </div>
  <div class="col-md-4">
    <app-label label="Sektor:">
      {{ application?.graveSector || '-' }}
    </app-label>
  </div>
  <div class="col-md-4">
    <app-label label="Rząd:">
      {{ application?.graveRow || '-' }}
    </app-label>
  </div>
  <div class="col-md-4">
    <app-label label="Numer:">
      {{ application?.graveNumber || '-' }}
    </app-label>
  </div>
  <div class="col-12">
    <app-label label="Oświadczam, że jestem jednym dysponentem grobu:">
      {{ application?.soleGraveAdmin ? 'Tak' : 'Nie' }}
    </app-label>
  </div>
</div>
@if (personData) {
  <br>
  <dl class="mb-2">
    <dt class="mb-3">
      <strong>Dane osoby która ma zostać pochowana</strong>
    </dt>
    <dd>
      <ul>
        <li>
          <app-label label="Imię:">
            {{ application?.personFirstName || '-' }}
          </app-label>
        </li>
        <li>
          <app-label label="Nazwisko:">
            {{ application?.personLastName || '-' }}
          </app-label>
        </li>
        <li>
          <app-label label="Data urodzenia:">
            {{ application?.dateOfBirth | date }}
          </app-label>
        </li>
        <li>
          <app-label label="Data śmierci:">
            {{ application?.dateOfDeath | date }}
          </app-label>
        </li>
        <li>
          <app-label label="Oświadczam, że dane zawarte w deklaracji podano zgodnie z prawdą:">
            {{ application?.declarationOfDataAccuracy ? 'Tak' : 'Nie' }}
          </app-label>
        </li>
        @if (!application?.soleGraveAdmin) {
          <li>
            <app-label label="Ilość pozostałych dysponentów:">
              {{ application?.numberOfRemainingDisposers || 0 }}
            </app-label>
          </li>
        }
      </ul>
    </dd>
  </dl>
}
